import { injectLoginAsCheck } from '@ti/core/common/contracts'

/**
 * Whether this tab is in Login as. Connecting an app grants the signed-in account's own access,
 * never an impersonated one, and the API requests of this flow deliberately do not carry the
 * login-as header, so the server could not tell: this check is the control.
 */
export function injectMcpLoginAsCheck(): () => boolean {
  return injectLoginAsCheck()
}
